import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../speakEasy.css";
import "./category.css";
import { setBackButtonUrl } from "../uiSlice";
import { selectAdminToken } from "../../admin/sessionSlice";
import { bootstrapStageAndReport } from "../../functions/stageReportSync";
import { SPEAK_EASY_CATEGORIES } from "../../functions/speakEasyCategories";
import useUnlockPageScroll from "../useUnlockPageScroll";
import cat1 from "./img/cat1.png";
import cat2 from "./img/cat2.png";
import cat3 from "./img/cat3.png";

const CATEGORY_IMAGES = [cat1, cat2, cat3];

function getStoredUser(authUser) {
  if (authUser && typeof authUser === "object") return authUser;
  try {
    return JSON.parse(sessionStorage.getItem("userData") || "{}") || {};
  } catch {
    return {};
  }
}

function isDemoUser(user) {
  const role = String(user.role || "").toLowerCase();
  const source = String(user.source || "").toUpperCase();
  const sid = String(user.sessionId || "");
  return sid === "demobypass" || role === "demobypass" || source === "DEMO" || sid.startsWith("demo");
}

/** Category picker from old/category.php: title + Warm-up / Explore / Introspect cards. */
export default function Category() {
  const dispatch = useDispatch();
  const { user } = useSelector((s) => s.auth);
  const { status: themeStatus, data: themeData } = useSelector((s) => s.theme);
  const adminToken = useSelector(selectAdminToken);
  const storedUser = useMemo(() => getStoredUser(user), [user]);

  useUnlockPageScroll();

  useEffect(() => {
    dispatch(setBackButtonUrl("/rules"));
  }, [dispatch]);

  // old/category.php inserts the player's `stat` row and report (../add_report.php).
  useEffect(() => {
    bootstrapStageAndReport({
      backendBase: String(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, ""),
      adminToken,
      storedUser,
      isDemoBypass: isDemoUser(storedUser),
    });
  }, [adminToken, storedUser]);

  if (themeStatus === "loading" && !themeData) {
    return (
      <div className="quiz-loader-container">
        <div className="quiz-loader" />
      </div>
    );
  }

  return (
    <div className="se-page se-category-page">
      {themeData?.sub_title ? (
        <h2 className="se-title se-category-title" style={{ color: themeData.landing_page_title_color }}>
          {themeData.sub_title}
        </h2>
      ) : null}

      <div className="se-category-list">
        {SPEAK_EASY_CATEGORIES.map((category, i) => (
          <Link
            key={category}
            to={`/game?category=${encodeURIComponent(category)}`}
            className="se-category-card"
          >
            <img src={CATEGORY_IMAGES[i]} alt={category} />
          </Link>
        ))}
      </div>

      <div className="se-rotate-overlay" aria-hidden>
        Please rotate your device for the best experience
      </div>
    </div>
  );
}
